module.exports = __webpack_public_path__ + "img/neck-ectomorph-male.94c23776.svg";